import { useStrings } from "@1js/localization-components";
import { facetsContain, type Filter } from "@1js/pl-card-components";
import { Body1, Button, CardHeader } from "@fluentui/react-components";
import { ChevronLeftRegular, ChevronRightRegular } from "@fluentui/react-icons";
import * as React from "react";
import { useStyles } from "../AllPrompts/AllPrompts.web.styles";
import { SeeAll, SeeAllYourPrompts } from "./SectionHeader.string";

export type SectionHeaderProps = {
  title: string;
  seeAllFilter: Record<string, string[]>;
  isSeeAllButtonEnabled: boolean;
  selectedFacets: Record<string, string[]>;
  filters: Filter[];
  handleFilterChange: (
    selectedValues: Record<string, string[]>,
    filters: Filter[]
  ) => void;
};

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  seeAllFilter,
  isSeeAllButtonEnabled,
  selectedFacets,
  filters,
  handleFilterChange,
}) => {
  const styles = useStyles();
  const localizations = useStrings({
    SeeAll,
    SeeAllYourPrompts,
  });
  const isDetailedViewEnabled = facetsContain(seeAllFilter, selectedFacets);

  return (
    <div className={styles.headerContainer}>
      <>
        {isDetailedViewEnabled ? (
          <Button
            appearance="transparent"
            icon={<ChevronLeftRegular />}
            iconPosition={"before"}
            className={styles.headerGoBackButton}
            onClick={() => {
              for (const key of Object.keys(seeAllFilter)) {
                delete selectedFacets[key];
              }
              handleFilterChange(selectedFacets, filters);
            }}
          >
            {localizations.SeeAllYourPrompts()}
          </Button>
        ) : (
          <>
            <CardHeader
              className={styles.header}
              header={<Body1 className={styles.headerText}>{title}</Body1>}
            />
            {isSeeAllButtonEnabled && (
              <Button
                appearance="transparent"
                icon={<ChevronRightRegular />}
                iconPosition={"after"}
                data-testid="see-all-button"
                className={styles.headerSeeAllButton}
                onClick={() => {
                  handleFilterChange(
                    {
                      ...selectedFacets,
                      ...seeAllFilter,
                    },
                    filters
                  );
                }}
              >
                {localizations.SeeAll()}
              </Button>
            )}
          </>
        )}
      </>
    </div>
  );
};
